import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import { Map, TileLayer } from 'react-leaflet';
import Leaflet from 'leaflet';
import _ from 'lodash';
import moment from 'moment';

import { getUserDisplayNameFromEmail } from '../../helpers/format';
import { GEO_CONSTANTS } from '../../config/constants';
import NewsMarker from './NewsMarker';

class MapListView extends Component {
  static propTypes = {
    initialPosition: PropTypes.object,
    newsItemsObjects: PropTypes.array,
    height: PropTypes.number,
    width: PropTypes.number,
  };

  static defaultProps = {
    newsItemsObjects: [],
    width: null,
    height: 500,
    initialPosition: null,
  }

  // 47.465824, -0.546131
  //  icon={() => <Icon color="red" name="marker" />}
  render() {
    const news = this.props.newsItemsObjects;
    let lat = this.props.initialPosition ? this.props.initialPosition.lat : null;
    let lng = this.props.initialPosition ? this.props.initialPosition.lng : null;
    let zoom = this.props.initialPosition ? this.props.initialPosition.zoom : null;
    let bounds = null;

    const mapProps = {};


    if (!lat || !lng || !zoom) {
      if (news.length === 1) {
        lat = parseFloat(news[0].latitude);
        lng = parseFloat(news[0].longitude);
        zoom = 11;
        mapProps.center = [lat, lng];
        mapProps.zoom = zoom;
      } else if (news.length > 1) {
        bounds = Leaflet.latLngBounds(
          Leaflet.latLng(
            _.minBy(news, i => parseFloat(i.latitude)).latitude,
            _.minBy(news, i => parseFloat(i.longitude)).longitude,
          ),
          Leaflet.latLng(
            _.maxBy(news, i => parseFloat(i.latitude)).latitude,
            _.maxBy(news, i => parseFloat(i.longitude)).longitude,
          ),
        ).pad(0.15);

        mapProps.bounds = bounds;
        // mapProps.boundsOptions = Leaflet.point(10, 10);
      } else {
        ({ lat, lng, zoom } = GEO_CONSTANTS.initialPosAndZoom);
        mapProps.center = [lat, lng];
        mapProps.zoom = zoom;
      }
    } else {
      mapProps.center = [lat, lng];
      mapProps.zoom = zoom;
    }

    const styles = {};
    if (this.props.width) {
      styles.width = this.props.width;
    }
    if (this.props.height) {
      styles.minHeight = this.props.height;
      styles.height = this.props.height;
    }
    // console.log(news);
    return (
      <Container>
        <Map
          {...mapProps}
          style={styles}
          useFlyTo
        >
          <TileLayer
            attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
          />
          {
            _.map(news, (i) => {
              if (!i.latitude || !i.longitude || (i.latitude === '0' && i.longitude === '0')) {
                return null;
              }
              let type;
              switch (i.type) {
                case 'Information':
                  type = 'info';
                  break;
                case 'Alerte':
                  type = 'alert';
                  break;
                default:
                  type = 'info';
                  break;
              }
              const date = moment(i.date, 'DD/MM/YY HH:mm').format('DD/MM/YYYY à HH:mm');
              return (
                <NewsMarker
                  key={i.key}
                  position={{ lat: parseFloat(i.latitude), lng: parseFloat(i.longitude) }}
                  type={type}
                  title={i.titre}
                  subtitle={(i.by && date) ? `Publié par ${getUserDisplayNameFromEmail(i.by)} le ${date}` : null}
                  content={i.message}
                />
              );
            })
          }
        </Map>
      </Container>
    );
  }
}

export default MapListView;



// WEBPACK FOOTER //
// ./src/components/Maps/MapListView.js